export const EXPERIENCE_INTERN = 'intern'

export const LEGAL_RELATIONSHIP_FULL_TIME = 'fulltime'
export const LEGAL_RELATIONSHIP_PART_TIME = 'parttime'
export const LEGAL_RELATIONSHIP_OTHER = 'other'

export const LEVEL_NONE = 'none'
export const LEVEL_BASIC = 'basic'
export const LEVEL_INDEPENDENT = 'independent'
export const LEVEL_PROFICIENT = 'proficient'
export const LEVEL_OTHER = 'other'

export const OTHER_LEGAL_RELATIONSHIP_NONE = 'none'

export const WORKLOCATION_TYPE_COUNTY = 'county'
export const WORKLOCATION_TYPE_COUNTRY = 'country'
export const WORKLOCATION_TYPE_DISTRICT = 'district'

export const SKILL_CATEGORY_DRIVING_LICENCE = 'drivinglicence'
export const SKILL_CATEGORY_IT = 'it'



// WEBPACK FOOTER //
// ./src/components/Adverts/constants.js